export default "__VITE_ASSET__CCyxFR7l__"